// extracted by mini-css-extract-plugin
export default {"root":"OeAQL","cols":"DArQv","submit":"_2ml2"};